export enum LoaderAnimationEnum {
  DEFAULT = '300ms',
}

export type LoaderAnimationEnumType = keyof typeof LoaderAnimationEnum;
